import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import Layout from './components/Layout/Layout';
import './styles/global.css';
import './styles/responsive.css';

// Lazy load route components for code splitting
const HomePage = lazy(() => import('./components/Home/HomePage'));
const ArticleList = lazy(() => import('./components/Article/ArticleList'));
const ArticleDetail = lazy(() => import('./components/Article/ArticleDetail'));
const NotFound = lazy(() => import('./components/NotFound/NotFound'));

// Loading fallback component
function LoadingFallback() {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '400px',
      color: '#eaeaea'
    }}>
      <div>加载中...</div>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Layout>
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              {/* 首页路由 */}
              <Route path="/" element={<HomePage />} />
              
              {/* 分类列表路由 */}
              <Route path="/category/:categoryId" element={<ArticleList />} />
              
              {/* 文章详情路由 */}
              <Route path="/article/:categoryId/:articleId" element={<ArticleDetail />} />
              
              {/* 404 页面 */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </Layout>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
